<template>
  <pa-header></pa-header>
  <div class="text-center flex items-center justify-center py-40" v-if="loading">
    <div class="lds-ripple">
      <div></div>
    </div>
    Loading please wait...
  </div>
  <div class="container-fluid">
    <div class="row">
      <div v-for="(v,index) in videos" v-bind:key="index" class="col-sm-2">
        <a v-bind:tabindex="index" @click="openVideo(v)" @keyup.enter="openVideo(v);$event.preventDefault()" class="yt-video mb-4 block video rounded shadow-lg p-4">
          <img class="rounded mb-3" style="max-width: 100%" v-bind:src="v.snippet.thumbnails.medium.url"/>
        </a>
      </div>
    </div>
  </div>

</template>
<script>
import axios from "axios";
import PaHeader from "@/views/Pa-Header";

var SpatialNavigation = window.SpatialNavigation;

export default {
  components: {PaHeader},
  data() {
    return {
      videos: [],
      loading: false
    }
  },
  methods: {
    openVideo(v) {
      console.log(v.snippet)
      this.$router.push({
        name: "pa-youtube", //use name for router push
        params: {id: v.id.videoId}
      });
    }
  },
  mounted() {
    var el = document.querySelectorAll('.router-link-exact-active')[0];
    if (el) el.classList.add('active');
    SpatialNavigation.focus('.router-link-exact-active');
    this.loading = true;
    axios.get('http://tv.primeasianews.com/api/youtube.php')
        .then((res) => {
          this.$data.videos = [...res.data];
          SpatialNavigation.makeFocusable();
          SpatialNavigation.focus();
          // SpatialNavigation.focus(e.target)
        })
        .catch(() => {
        })
        .finally(() => {
          this.loading = false;
        });
  }
}
</script>
